import { ILeaderboardTableWithScores } from './leaderboard-table-with-scores.interface';

export interface IGetBoardDTO {
  table: ILeaderboardTableWithScores;
}